import { Injectable } from "@angular/core";
import {
  NgbDateStruct,
  NgbDatepickerI18n,
} from "@ng-bootstrap/ng-bootstrap";
import { LocaleService } from "./locale.service";

@Injectable()
export class LocalizedDatepickerI18n extends NgbDatepickerI18n {
  constructor(private localeService: LocaleService) {
    super();
  }

  getWeekdayLabel(
    weekday: number,
    width: Exclude<Intl.DateTimeFormatOptions["weekday"], undefined> = "short",
  ): string {
    const date = new Date(Date.UTC(2024, 0, weekday));

    return new Intl.DateTimeFormat(this.localeService.getIntlLocale(), {
      weekday: width,
      timeZone: "UTC",
    }).format(date);
  }

  getMonthShortName(month: number, _year?: number): string {
    return this.formatMonth(month, "short");
  }

  getMonthFullName(month: number, _year?: number): string {
    return this.formatMonth(month, "long");
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return this.localeService.formatDate(
      new Date(date.year, date.month - 1, date.day),
      {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      },
    );
  }

  private formatMonth(
    month: number,
    width: "short" | "long",
  ): string {
    return new Intl.DateTimeFormat(this.localeService.getIntlLocale(), {
      month: width,
      timeZone: "UTC",
    }).format(new Date(Date.UTC(2024, month - 1, 1)));
  }
}
